import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { ZendeskUser } from './useZDUser.interface';
import fetchZDUser from './useZDUser.request';

import { useMember } from 'modules/common/queries/member';

export default function useZDUser(options?: UseQueryOptions<ZendeskUser>) {
    const { data: member } = useMember({ staleTime: Infinity });

    return useQuery({
        queryKey: ['ZDUserId', member?.uuid],
        queryFn: () => fetchZDUser(member?.uuid || ''),
        enabled: Boolean(member?.uuid),
        staleTime: Infinity,
        cacheTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchOnMount: false,
        retry: 1,
        retryDelay: 2000,
        ...options,
    });
}
